import { Button, Footer } from 'flowbite-react'
import React from 'react'
// import { BsTwitter, BsFacebook } from "react-icons/bs";
import { TfiGoogle, TfiFacebook, TfiTwitterAlt } from 'react-icons/tfi'

function SimpleFooter() {
  return (
    <footer className="w-full bg-[#E9EEF4] py-12 px-4">
        <div className="flex space-x-6 justify-center">
        {/* <a className="iconBtn bg-[#1E9BEB]/70 hover:bg-[#1E9BEB]" href="#" target="_blank" rel="noreferrer">
          <TfiTwitterAlt className="h-7 w-7" />
        </a>
        <a className="iconBtn bg-[#4064AC]/70 hover:bg-[#4064AC]" href="#" target="_blank" rel="noreferrer">
          <TfiFacebook className="h-7 w-7" />
        </a>
        <a className="iconBtn bg-[#D64937]/70 hover:bg-[#D64937]" href="#" target="_blank" rel="noreferrer">
          <TfiGoogle className="h-7 w-7" />
        </a> */}
      </div>
    </footer>
  )
}

export default SimpleFooter